import * as React from 'react'
import { filterXSS } from 'xss'

interface IProps extends React.HTMLAttributes<any> {
  html: string
  Tag?: string
}

const SafeInnerHtml = ({ html, Tag = 'div', ...restProps }: IProps) => {
  return (
    <Tag dangerouslySetInnerHTML={{ __html: filterXSS(html) }} {...restProps} />
  )
}

export default SafeInnerHtml
